<form class="metro-card-number"
      [formGroup]="cardNumberForm">
    <input *ngFor="let section of cardNumberSections"
           mmInput
           digitOnly
           inputmode="numeric"
           [class]="'metro-card-number__section metro-card-number__section--' + section.name"
           [minLength]="section.minLength"
           [maxLength]="section.maxLength"
           [formControlName]="section.name"
           (paste)="onPaste($event)"
           (blur)="onTouched()"
           [mmTestTarget]="'metro-card-number-section-' + section.name">
</form>
